import HOCAddPatient from './hoc-add-patient';

export default HOCAddPatient;
